// utils.js
export const Utils = {
    scrollToElement(id) {
        const el = document.getElementById(id);
        if (!el) return;
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    },

    preloadAudio(path) {
        const audio = new Audio(path);
        audio.load();
        return audio;
    },

    throttle(fn, delay) {
        let last = 0;
        let timeout;
        return function (...args) {
            const now = Date.now();
            const remaining = delay - (now - last);
            if (remaining <= 0) {
                last = now;
                fn.apply(this, args);
            } else {
                clearTimeout(timeout);
                timeout = setTimeout(() => {
                    last = Date.now();
                    fn.apply(this, args);
                }, remaining);
            }
        };
    },

    now() {
        return performance && performance.now ? performance.now() : Date.now();
    }
};
